import Page from 'src/apipages/guides/start/index';

export default Page;
